import React, { useState } from 'react';
import { NAV_MENU_ITEMS } from '../config/constants';
import authService from '../services/authService';
import './Sidebar.css';

const Sidebar = ({ activePage, onPageChange }) => {
  const [expandedMenus, setExpandedMenus] = useState({});
  const user = authService.getCurrentUser();
  const permissions = authService.getPermissions();

  const filteredMenuItems = NAV_MENU_ITEMS.filter(item =>
    permissions.includes(item.permission)
  );

  const toggleSubmenu = (menuId) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuId]: !prev[menuId]
    }));
  };

  const handleMenuClick = (item) => {
    if (item.submenus && item.submenus.length > 0) {
      toggleSubmenu(item.id);
      if (!expandedMenus[item.id] && item.submenus.length > 0) {
        onPageChange(item.submenus[0].slug);
      }
    } else {
      onPageChange(item.slug);
    }
  };

  const handleSubmenuClick = (submenuSlug, e) => {
    e.stopPropagation();
    onPageChange(submenuSlug);
  };

  const isMenuActive = (item) => {
    if (item.slug === activePage) return true;
    if (item.submenus) {
      return item.submenus.some(submenu => submenu.slug === activePage);
    }
    return false;
  };

  const handlePosLogin = () => {
    window.open('https://cashier.litegrocer.lk', '_blank');
  };

  const handleEcommerceSite = () => {
    window.open('https://litegrocer.lk', '_blank');
  };

  return (
    <div className="sidebar">
      {/* Header Section */}
      <div className="sidebar-header">
        <div className="brand-logo">
          <div className="logo-icon">⚡</div>
          <div className="logo-text">
            <h3>Lite Grocer</h3>
            <span>Admin Panel</span>
          </div>
        </div>

        <div className="user-profile">
          <div className="user-avatar">
            {user?.full_name?.charAt(0)?.toUpperCase() || 'U'}
          </div>
          <div className="user-details">
            <div className="user-name">{user?.full_name || 'User'}</div>
            <div className="user-role">{user?.role_type || 'Administrator'}</div>
          </div>
        </div>
      </div>

      {/* Quick Action Buttons */}
      <div className="quick-actions">
        <button className="action-btn pos-btn" onClick={handlePosLogin}>
          <span className="btn-icon">💻</span>
          <span className="btn-text">POS Cashier Login</span>
        </button>
        <button className="action-btn ecom-btn" onClick={handleEcommerceSite}>
          <span className="btn-icon">🛒</span>
          <span className="btn-text">E-commerce Site</span>
        </button>
      </div>

      {/* Navigation Menu */}
      <nav className="sidebar-nav">
        <div className="nav-section">
          <div className="section-label">MAIN NAVIGATION</div>
          <ul className="nav-menu">
            {filteredMenuItems.map(item => (
              <li key={item.id} className={`nav-item ${isMenuActive(item) ? 'active' : ''}`}>
                <div
                  className="nav-link"
                  onClick={() => handleMenuClick(item)}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-text">{item.name}</span>
                  {item.submenus && item.submenus.length > 0 && (
                    <span className={`nav-arrow ${expandedMenus[item.id] ? 'expanded' : ''}`}>
                      ▼
                    </span>
                  )}
                </div>

                {item.submenus && item.submenus.length > 0 && expandedMenus[item.id] && (
                  <ul className="submenu">
                    {item.submenus.map(submenu => (
                      <li key={submenu.id} className="submenu-item">
                        <button
                          className={`submenu-link ${activePage === submenu.slug ? 'active' : ''}`}
                          onClick={(e) => handleSubmenuClick(submenu.slug, e)}
                        >
                          <span className="submenu-dot"></span>
                          {submenu.name}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <div className="system-status">
          <div className="status-indicator online"></div>
          <span>System Online</span>
        </div>
        <div className="version-info">
          <small>v2.0.1</small>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;